import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

// default socials
const icons = [
  "facebook",
  "instagram",
  "twitter",
  "linkedin",
  "github",
  "website",
];

const MultiInputTag = ({
  label,
  length,
  name,
  icon,
  defaultValue,
  type,
  required,
  handleRemoveElement,
}) => {
  const [visibility, setVisibility] = useState(true);

  // const handleDelete = (event) => {
  //   setVisibility(false);
  // };

  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end" : "gap-1 items-end hidden"}
    >
      <div className="mb-4">
        <label className="block mb-1">
          <span className="text-md font-semibold">
            {length ? label + " " + length : label}
          </span>
        </label>
        <div className="flex gap-4 items-center">
          <label className="flex">
            <div className="relative">
              <span className="absolute top-4 right-1.5 z-[1]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4 text-white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
              <select
                defaultValue={defaultValue?.name}
                className="bg-secondary py-2.5 px-3 pr-6 rounded-l-md text-white uppercase outline-none"
              >
                {icons.map((item, index) => (
                  <option
                    key={index}
                    value={item}
                    className={
                      item === icon
                        ? "text-gray-700 font-medium"
                        : "text-gray-50"
                    }
                  >
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <input
              name={visibility ? name : ""}
              defaultValue={defaultValue?.link}
              type={type}
              className="w-full darkPrimary border border-gray-300 rounded-r-md min-w-[10rem] px-3 py-2 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
              required={required}
            />
          </label>
          <div>
            <button
              type="button"
              onClick={() => handleRemoveElement(label)}
              className="p-2 rounded-full border border-dashed dark:border-gray-700 border-gray-400 hover:border-darkPrimary transition duration-150"
            >
              <AiOutlineMinus />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiInputTag;
